<template>
  <div class="stock-wrap" key="1">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出excel -->
        <!-- <el-form-item style="float: right; margin-right: 0" v-if="funcView.export_stock">
          <el-button class="table-set" style="vertical-align: top"><i class="icon icon-daochu"></i></el-button>
        </el-form-item> -->
        <el-form-item v-if="funcView.operations_add">
          <el-button type="primary" @click="onCreateReport()">{{ $t('base_operations.scywbg') }}</el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_operations.gong_si_ming_cheng')" v-model="formSearch.orgName" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('base_operations.sheng_cheng_shi_jian')" class="gen-time-item" style="width: 50%">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.genDateRange"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('base_operations.kai_shi_ri')"
            :end-placeholder="$t('base_operations.jie_shu_ri')"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['realName', 'action']"
        tableCode="operations_list"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
      >
        <template
          slot="realName"
          slot-scope="scope"
        >
           {{ scope.row.realname||'-' }} / {{ scope.row.userName||'-'  }}
        </template>
        <template slot="action" slot-scope="scope">
          <el-button v-if="funcView.operations_download && +scope.row.reportGenState === 2" type="text" size="mini" @click="onDownload(scope.row)">{{ $t('base_operations.xia_zai') }}</el-button>
          <el-button v-if="funcView.operations_email && +scope.row.reportGenState === 2" type="text" size="mini" @click="onOpenEmailDialog(scope.row)">{{ $t('base_operations.you_jian') }}</el-button>
          <el-button v-if="funcView.operations_retry && +scope.row.reportGenState === 4" type="text" size="mini" @click="onRetry(scope.row)">{{ $t('base_operations.chong_shi') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>

    <work-report-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onReportSuccess"></work-report-dialog>
    <operations-email-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onEmailSuccess"></operations-email-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import moment from 'moment';
import workReportDialog from './operations_report_dialog.vue';
import operationsEmailDialog from './operations_email_dialog.vue';

export default {
  name: 'operations',
  mixins: [resetFormSearchMixins],
  components: {
    workReportDialog,
    operationsEmailDialog,
  },
  props: {},
  data() {
    return {
      tableSelect: [],
      formSearch: {
        orgName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        genDateRange: [
          this.$momentWorld(moment(this.$getLocalTime()).startOf('month').format('YYYY-MM-DD 00:00:00')),
          this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59')),
        ],
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    onCreateReport() {
      this.dialogModel = {
        title: this.$t('base_operations.scywbg'),
        data: {},
      };
      this.dialogVisible = true;
    },
    getTableList() {
      this.syncGenTimeRange();
      const reqData = {
        ...this.formSearch,
      };
      delete reqData.genDateRange;
      this.$getJSON(apis.workReportPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    syncGenTimeRange() {
      if (!this.formSearch.genDateRange || this.formSearch.genDateRange.length < 2) {
        this.formSearch.genStartDate = '';
        this.formSearch.genEndDate = '';
        return;
      }
      this.formSearch.genStartDate = this.formSearch.genDateRange[0];
      this.formSearch.genEndDate = this.formSearch.genDateRange[1];
    },
    onReportSuccess() {
      this.dialogVisible2 = false;
      this.getTableList();
    },
    onEmailSuccess() {
      this.dialogVisible = false;
    },
    onDownload: function (row) {
      this.$getFileList({
        bizId: row.genRecordId,
        bizType: 'ras.generate',
      }).then((list) => {
        list.forEach((item) => {
          this.$downloadFile(this.getAttachUrl(item), item.attachName);
        });
      });
    },
    onOpenEmailDialog(row) {
      this.dialogModel2 = {
        title: this.$t('base_operations.fa_song_bao_gao'),
        data: {
          genRecordId: row.genRecordId,
          email: row.pushEmail || '',
        },
      };
      this.dialogVisible2 = true;
    },
    onRetry(row) {
      this.$postJSON(`${apis.workReportRetry}/${row.genRecordId}`, {}, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.getTableList();
      });
    },
  },
  created() {},
  mounted() {
    this.getTableList();
    this.getFuncView();
  },
};
</script>

<style lang="scss">
</style>
